import PropTypes from 'prop-types'

import type { AnyAction } from '@reduxjs/toolkit'

/*
EXAMPLE:
{
  data: [],
  error: {},
  key: 'ABC',
  loading: false,
  loaded: false,
  pagination: {},
}
*/

export const ServerResponseSchema = PropTypes.shape({
  key: PropTypes.string,
  data: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.object), PropTypes.object]),
  error: PropTypes.shape({
    code: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    error: PropTypes.string,
    message: PropTypes.string,
    trace: PropTypes.string,
  }),
  loaded: PropTypes.bool,
  loading: PropTypes.bool,
  pagination: PropTypes.shape({
    current_page: PropTypes.number,
    from: PropTypes.number,
    last_page: PropTypes.number,
    next_page_url: PropTypes.string,
    per_page: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    prev_page_url: PropTypes.string,
    to: PropTypes.number,
    total: PropTypes.number,
  }),
})

export interface ServerResponseSchema<TData> {
  key?: string
  data: TData
  error?: {
    code: number | string
    error: string
    message: string
    trace?: string
  }
  loaded?: boolean
  loading?: boolean
  originalAction?: AnyAction
  pagination?: {
    current_page: number
    from: number
    last_page: number
    next_page_url: string
    per_page: number
    prev_page_url: string
    to: number
    total: number
  }
  serverResponse?: ServerResponseSchema<TData>
}
